import { Button, Col, Popconfirm, Popover, Row } from 'antd'
import React from 'react'
import { t } from 'i18next'

export default function AdminSlotActions ({ form, slot, cancel, back, delay }) {
  return (
    <Row>
      <Col span={8} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Popconfirm
          title={t('Admin.AdminSlotPage.cancelSlot')}
          onConfirm={cancel}
          okText={t('Admin.message.yes')}
          cancelText={t('Admin.message.no')}
        >
          <Button danger disabled={slot.is_cancel}>
            {t('Admin.btn.cancel')}
          </Button>
        </Popconfirm>
        {slot.delayable &&
          <Popconfirm
            title={t('Admin.AdminSlotPage.delaySlot')}
            onConfirm={delay}
            okText={t('Admin.message.yes')}
            cancelText={t('Admin.message.no')}
          >
            <Button type='primary' disabled={!slot.delayable}>
              {t('Admin.btn.delay')}
            </Button>
          </Popconfirm>
        }
        {!slot.delayable &&
          <Popover content={t('Admin.AdminSlotPage.cannotDelay')}>
            <Button type='primary' disabled>
              {t('Admin.btn.delay')}
            </Button>
          </Popover>
        }
      </Col>
      <Col span={10} />
      <Col span={6} style={{ float: 'right', display: 'flex', justifyContent: 'space-evenly' }} >
        <Button type="primary" onClick={back}>
          {t('Admin.btn.back')}
        </Button>
        <Button type="primary" htmlType="submit" onClick={form.submit} disabled={slot.is_cancel}>
          {t('Admin.btn.submit')}
        </Button>
      </Col>
    </Row>
  )
}
